import { GameInterface } from "../../interfaces";

const games: GameInterface[] = [
    { id: 3636, title: "Sweet Bonanza", provider: "pragmatic" },
    { id: 3680, title: "Sweet Bonanza 1000", provider: "pragmatic" },
    { id: 3595, title: "Sugar Rush", provider: "pragmatic" },
    { id: 3641, title: "Release the Kraken", provider: "pragmatic" },
    { id: 3638, title: "Gates of Olympus Super Scatter", provider: "pragmatic" },
    { id: 3682, title: "Gates of Olympus", provider: "pragmatic" },
    { id: 3640, title: "The Dog House Megaways", provider: "pragmatic" },
    { id: 3738, title: "Mine Slot", provider: "inout" },
    { id: 3223, title: "Chicken Road", provider: "inout" },
    { id: 3779, title: "Chiсken Road 2.0", provider: "inout" },
    { id: 2534, title: "Dead or Alive", provider: "netent" },
    { id: 2840, title: "Dead or Alive 2", provider: "netent" },
    { id: 2713, title: "Bee Hive Bonanza", provider: "netent" },
    { id: 2993, title: "Football: Champions Cup", provider: "netent" },
    { id: 2835, title: "Jumanji", provider: "netent" },
    { id: 2441, title: "Steam Tower", provider: "netent" },
    { id: 2709, title: "King of Slots", provider: "netent" },
    { id: 3534, title: "Flowers", provider: "netent" },
    { id: 3429, title: "Vikings", provider: "netent" },
    { id: 3512, title: "King of 3 Kingdoms", provider: "netent" },
    { id: 3159, title: "Ghost Pirates", provider: "netent" },
    { id: 3119, title: "The Legend of Shangri-La: Cluster Pays", provider: "netent" },
];

export { games };